import React from 'react';
import { applyStyles } from 'util/helpers';
import Image from 'components/common/Image';
import i18n from 'i18n';
import DatepickerField from 'components/common/DatepickerField';
import Button from 'components/common/Button';
import { get } from 'lodash';
import CustomMedia from 'util/custom-media-query';
import icBtnUpPC1x from 'assets/images/PC/@1x/ic_btn_up.png';
import icBtnUpPC2x from 'assets/images/PC/@2x/ic_btn_up@2x.png';
import icBtnUpSP2x from 'assets/images/SP/@2x/ic_btn_up@2x.png';
import icBtnUpSP3x from 'assets/images/SP/@3x/ic_btn_up@3x.png';
import icBtnDownPC1x from 'assets/images/PC/@1x/ic_btn_down.png';
import icBtnDownPC2x from 'assets/images/PC/@2x/ic_btn_down@2x.png';
import icBtnDownSP2x from 'assets/images/SP/@2x/ic_btn_down@2x.png';
import icBtnDownSP3x from 'assets/images/SP/@3x/ic_btn_down@3x.png';
import icDatePC1x from 'assets/images/PC/@1x/ic_date.png';
import icDatePC2x from 'assets/images/PC/@2x/ic_date@2x.png';
import icDateSP2x from 'assets/images/SP/@2x/ic_date@2x.png';
import icDateSP3x from 'assets/images/SP/@3x/ic_date@3x.png';
import {
  commonStyle,
  pcStyle,
  spStyle
} from 'components/OrderAggregators/styles/order';
import {
  renderAddressOneLine,
  renderWrappingInfoDetail,
  renderMessageCardInfo
} from 'components/OrderAggregators/scripts/order';

class Order extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      opened: true
    };
    this.contentRef = React.createRef();
  }

  handleClickToggle() {
    this.setState({
      opened: !this.state.opened
    });
  }

  render() {
    const { className, index, fieldName, getState, onClickEdit } = this.props;
    const formValues = get(getState().values, fieldName);

    if (formValues == null) {
      return null;
    }

    return (
      <div className={className}>
        <div className="header-panel">
          <button
            type="button"
            className="btn-toggle"
            onClick={() => this.handleClickToggle()}
          >
            {this.state.opened ? (
              <Image
                pc1x={icBtnUpPC1x}
                pc2x={icBtnUpPC2x}
                sp2x={icBtnUpSP2x}
                sp3x={icBtnUpSP3x}
                alt="ic_btn_up"
              />
            ) : (
              <Image
                pc1x={icBtnDownPC1x}
                pc2x={icBtnDownPC2x}
                sp2x={icBtnDownSP2x}
                sp3x={icBtnDownSP3x}
                alt="ic_btn_down"
              />
            )}
          </button>
          <h2>{`${i18n.t('orderAggregators:common:order.order')}${index}`}</h2>
          <Button
            buttonType="G-edit"
            type="button"
            className="header-btn btn-edit"
            onClick={() => onClickEdit(index - 1)}
          >
            {i18n.t('common:edit')}
          </Button>
        </div>
        <div
          className={`order-content ${this.state.opened ? '' : 'close'}`}
          style={{
            maxHeight: this.contentHeight
          }}
          ref={this.contentRef}
        >
          <table>
            <tbody>
              <tr>
                <th>{i18n.t('orderAggregators:common:order.orderCount')}</th>
                <td>
                  <span className="purchase-num">
                    {formValues.purchaseItem.num}
                    {i18n.t('common:sheet')}
                  </span>
                </td>
              </tr>
              <tr>
                <th>
                  {i18n.t('orderAggregators:common:order.validityPeriod')}
                </th>
                <td>
                  <div className="validity-period">
                    <DatepickerField
                      className="disabled"
                      name={`${fieldName}.purchaseItem.validatedOn`}
                      disabled={true}
                    />
                    <Image
                      pc1x={icDatePC1x}
                      pc2x={icDatePC2x}
                      sp2x={icDateSP2x}
                      sp3x={icDateSP3x}
                      alt="ic_date"
                    />
                    <DatepickerField
                      className="disabled"
                      name={`${fieldName}.purchaseItem.expiredOn`}
                      disabled={true}
                    />
                  </div>
                </td>
              </tr>
              <tr className="row-variable">
                <th>{i18n.t('orderAggregators:common:order.wrappingInfo')}</th>
                <td>
                  <div className="cell-wrapper">
                    <p className="value multiline">
                      {renderWrappingInfoDetail(formValues.wrappingInfo)}
                    </p>
                  </div>
                </td>
              </tr>
              <tr className="row-variable">
                <th>{i18n.t('orderAggregators:common:order.messageCard')}</th>
                <td>
                  <div className="cell-wrapper">
                    <p className="value multiline">
                      {renderMessageCardInfo(formValues.wrappingInfo)}
                    </p>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{i18n.t('orderAggregators:common:order.receiver')}</th>
                <td>
                  <div className="cell-wrapper">
                    <span className="value ellipsis">
                      {renderAddressOneLine(formValues.receiver)}
                    </span>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{i18n.t('orderAggregators:common:order.from')}</th>
                <td>
                  <div className="cell-wrapper">
                    <span className="value ellipsis">
                      {renderAddressOneLine(formValues.shipper)}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

const spStyle2 = CustomMedia.lessThan('medium')`
  .validity-period {
    display: flex;
    align-items: center;
    height: 17px;
  }
`;

export default applyStyles(Order)(commonStyle, pcStyle, spStyle, spStyle2);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/Confirmation/components/OrderConfirm.js